import { Tooltip } from '@maxtropy/components';
import { DataList } from '../types';
import styles from '../index.module.scss';
import dayjs from 'dayjs';

interface TimeAxisProps {
  pageLabel?: string;
  data?: DataList[];
}

const TimeAxis = ({ pageLabel, data = [] }: TimeAxisProps) => {
  return (
    <div className={styles.itemContent}>
      <div className={styles.statusBar}>
        {data.map((detail, index) => (
          <Tooltip
            key={index}
            placement="top"
            title={
              <>
                {dayjs(detail.ts).format('YYYY-MM-DD')}{' '}
                <span style={{ color: detail.flag ? '#ff9247' : 'inherit' }}>
                  {detail.flag ? pageLabel : `非${pageLabel}`}
                </span>
              </>
            }
          >
            <div className={`${styles.statusBlock} ${detail.flag ? styles.active : styles.inactive}`} />
          </Tooltip>
        ))}
      </div>
      <div className={styles.timeLabel}>
        <span>{dayjs(data[0]?.ts).format('MM-DD')}</span>
        <span>{dayjs(data[data.length - 1]?.ts).format('MM-DD')}</span>
      </div>
    </div>
  );
};

export default TimeAxis;
